import * as S from './styles';

const Logo = ({ type = 'bluedream', width = 'auto', height = 'auto' }) => {
  return <S.Container type={type} height={height} width={width} />;
};

export default Logo;
